import {
    Grid,
    Typography,
    withStyles,
    Theme,
    Box,
    Button,
    TextField,
    CircularProgress,
    FormControlLabel
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
// import fileDownload from 'js-file-download'
// import BulbOutlineIcon from 'mdi-react/BulbOutlineIcon'
import CancelIcon from 'mdi-react/CancelCircleOutlineIcon'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'
// import DownloadIcon from 'mdi-react/DownloadIcon'

import { useEffect, useState, useCallback, useLayoutEffect, useMemo } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { Dispatch } from 'redux'
import { reduxForm, change, formValueSelector, Field } from 'redux-form'
import { stepAfterShowingForward } from '../../actions/apartments'
import ConfirmationDialogRaw from '../../components/ConfirmationDialogRaw/ConfirmationDialog'
import { ReduxFormField, ReduxGoogleAutocomplete } from '../../components/FormInput/ReduxWrappers'
import ReduxCheckbox from '../../components/FormInput/ReduxWrappers/ReduxCheckbox'
import LoadingContainer from '../../components/LoadingContainer/LoadingContainer'
import OutlineLockPersonIcon from '../../images/ic_outline-lock-person.svg'
import suggestIcon from '../../images/suggest.svg'
import { charsSpace, onlyNums } from '../../libs/normalize/information'
import Api from '../../services/applications'
import i18n from '../../translations/i18n'
import { MuiClasses } from '../../types'
import { ApartmentInformation, DropDownItem } from '../../types/apartments'
import { AutocompleteOption } from '../../types/autocomplete'
import { ReduxForm } from '../../types/forms'
import { WaterFeeBasis } from '../../types/propValues/apartments'
import { StateInterface } from '../../types/states'
import {
    isInvalidCharacters,
    isPostalCode,
    noSpacesPhoneNum,
    noSpaceValue,
    required,
    requiredLocation,
    validateEmail,
    validatePhoneNumber
} from '../../utils/validation/forms'
import { MyInput } from '../NewApplication/Fields'
//import { BackButton } from '../InstantRentApplication/BackButton'
import StartAuthTrigger from '../InstantRentApplication/StartAuthTrigger'
import { ApplicationStatus } from '../../types/applications'
import ApplicationsApi from '../../services/applications'
import ShowingsApi from '../../services/showings'
import phoneAndHouse from '../../images/afterShowing/phoneAndHouse.svg'
import loginImage from '../../images/logInImage.svg'
import digivakuusEligible from '../../images/afterShowing/digivakuusEligible.svg'
import notDigivakuusEligible from '../../images/afterShowing/notDigivakuusEligible.svg'
import ApplicantDepositVerificator from './ApplicantDepositVerificator'

const styles = ({ breakpoints, typography }: Theme) => ({
    formContainer: {
        // padding: '35px 0 15px 0',
        // maxWidth: '550px',
        maxWidth: '1131px',
        margin: 'auto',
        marginTop: '3.5rem !important',
        '@media (max-width: 960px)': {
            marginTop: '1rem !important',
        }
    },
    modalMobile: {
        [breakpoints.down('sm')]: {
            margin: '20px'
        }
    },
    paymentOption: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        flexWrap: 'wrap',
        marginTop: '30px'
    } as const,
    paymentCard: {
        // width: '23% '
    },
    buttons: {
        margin: '2rem 0 2rem 0',
        width: '100%',
        [breakpoints.down('sm')]: {
            bottom: 0,
            margin: 0,
            marginTop: '2rem',
            marginBottom: '1.5rem',
            backgroundColor: '#fff',
            padding: '4px'
        }
    },
    fullWidthActionButtonNext: {
        borderRadius: '10px',
        '@media (max-width: 960px)': {
            marginLeft: '-4px',
            marginRight: '-4px'
        },
    },
    button: {
        // width: '48%',
        [breakpoints.down('sm')]: {
            borderRadius: 0
        }
    },
    buttonGridContainer: {
        width: '47.5%'
    },
    cancelTextButton: {
        color: '#D43838',
        fontSize: '1.375rem',
        height: '65px',
        textTransform: 'none' as const,
        background: 'none',
        boxShadow: 'none',
        fontWeight: 'bold' as const,
        backgroundColor: '#fff',
        '&:hover': {
            background: 'none',
            boxShadow: 'none'
        },
        [breakpoints.down('sm')]: {
            // marginBottom: '100px'
        }
    },
    skipIdentificationButton: {
        margin: '20px auto 32px',
        display: 'block',
        border: 'none',
        textDecoration: 'underline',
        color: '#94004A',
        textTransform: 'none' as const,
        '&:hover': {
            background: 'transparent',
            textDecoration: 'underline'
        },
        '& .MuiButton-label': {
            fontFamily: '"Circular Std", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 700,
            fontSize: 20,
            justifyContent: 'center'
        }
    },
    responsiveWidth: {
        [breakpoints.down('sm')]: {
            padding: '0 1rem'
        }
    },
    leaseContainer: {
        marginTop: '4rem',
        marginBottom: '4.5rem',
        [breakpoints.down('sm')]: {
            marginTop: '3.2rem',
            marginBottom: '2.25rem'
        }
    },
    moversSection: {
        marginTop: '3.6rem',
        [breakpoints.down('sm')]: {
            marginTop: '2rem'
        }
    },
    moversContainer: {
        padding: '40px 30px 47px 41px',
        borderRadius: '20px',
        [breakpoints.down('sm')]: {
            padding: '32px 30px 43px 30px'
        }
    },
    leaseDurationTitle: {
        marginBottom: '2rem',
        [breakpoints.down('sm')]: {
            marginBottom: '1.625rem'
        }
    },
    moversTitle: {
        marginBottom: '1.6rem',
        [breakpoints.down('sm')]: {
            marginBottom: '1.875rem'
        }
    },
    moversField: {
        margin: '1.4rem auto 1.2rem auto',
        '& .react-select__control': {
            padding: '2px 8px',
            borderRadius: '8px'
        },
        '& .react-select__placeholder': {
            fontSize: '16px'
        },
        [breakpoints.down('sm')]: {
            margin: '1.8rem auto 1.625rem auto'
        }
    },
    inlineDatePicker: {
        // border: '2px solid red',
        borderRadius: '8px'
    },
    labelText: {
        fontSize: typography.pxToRem(18)
    },
    formLabel: {
        fontSize: typography.pxToRem(20),
        [breakpoints.down('sm')]: {
            fontSize: typography.pxToRem(16),
            marginBottom: '8px'
        }
    },
    customInputLabel: {
        // Add custom styles for label
        paddingLeft: '5px', // Example padding
    },
    customInput: {
        // Add custom styles for input
        '& input': {
            paddingLeft: '5px', // Padding inside the input
        },
    },
    calendarInputContainer: {
        padding: '25px 32px 29px 32px',
        [breakpoints.down('sm')]: {
            // padding: '36px 16px 37px 42px'
            padding: '36px 25px 37px 25px;',
            marginBottom: '20px'
        }
    },
    containerStyle: {
        marginLeft: '30px',
        [breakpoints.down('sm')]: {
            marginLeft: '0px'
        }
    },
    sartDateRow: {
        height: '178px',
        alignItems: 'center',
        [breakpoints.down('sm')]: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        }
    },
    stepTwoInfo: {
        '> div': {
            display: 'flex'
        },
        [breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    stepTwoInfoDetails: {
        display: 'flex',
        [breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    dialogContanier: {
        paddingTop: '3.875rem',
        paddingBottom: '3.875rem'
    },
    authPrompt: {
        padding: '54px 0',
        marginTop: '1.5rem',
        [breakpoints.down('sm')]: {
            padding: '84px 0'
        }
    },
    applicantInfo: {
        // padding: '54px 0',
        marginTop: '51px',
        [breakpoints.down('sm')]: {
            padding: '2rem 0',
            marginBottom: '7rem'
        }
    },
    authDesc: {
        marginTop: '2rem',
        marginBottom: '1.5rem',
        [breakpoints.up('md')]: {
            textAlign: 'center'
        }
    },
    consentCheckbox: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        margin: '1rem auto 0 auto',
        '& .MuiFormControlLabel-label': {
            textAlign: 'center'
        },
        [breakpoints.down('sm')]: {
            justifyContent: 'flex-start',
            margin: '1rem 0 0 0',
            '& .MuiFormControlLabel-label': {
                textAlign: 'left'
            }
        }
    },
    consentError: {
        color: 'red',
        marginTop: '0.75rem',
        textAlign: 'center',
        [breakpoints.down('sm')]: {
            textAlign: 'left'
        }
    },
    requiredField: {
        '&:after': {
            content: '"*"',
            color: 'red'
        }
    },
    labelChecker: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '10px 0',
        [breakpoints.down('sm')]: {
            padding: '15px',
            paddingLeft: '2em',
            paddingRight: '1em',
            marginRight: '0'
        }
    },
    heading: {
        [breakpoints.down('sm')]: {
            fontSize: '1.1rem'
        }
    },
    mBottom: {
        marginBottom: '10px'
    },
    suggestIcon: {
        objectFit: 'contain',
        width: '30px',
        [breakpoints.down('sm')]: {
            marginBottom: '10px'
        }
    } as const,
    paragraphStyle: {
        fontSize: '1.1rem',
        '& span': {
            color: '#94004A'
        },
        [breakpoints.down('sm')]: {
            marginRight: '10px',
            marginLeft: '20px'
        }
    },
    modalSecondaryButton: {
        marginTop: '20px'
    },
    acceptedDeclinedFormContainer: {
        height: '100vh',
        alignItems: 'center',
        [breakpoints.up('md')]: {
            height: 'auto',
        },
    },
    step5Row: {
        alignItems: 'flex-start',   // ✅ align top
        minHeight: '100vh',     // still take full height if you want fullscreen feel
    },
    acceptedDeclinedText: {
        fontSize: '2rem',
        lineHeight: '2.5rem',
        marginBottom: '1.25rem',
        fontWeight: typography.fontWeightBold,
        marginLeft: '3.5rem',
        [breakpoints.between('md', 1200)]: {
            marginLeft: '6.3rem',
        },
        [breakpoints.down('md')]: {
            marginLeft: '1.79rem',
            marginRight: '1rem'  // Adjust this to what you find suitable for smaller screens
        },
    },
    acceptedDeclinedTextLastStep: {
        fontSize: '2rem',
        lineHeight: '2.5rem',
        marginBottom: '1.25rem',
        fontWeight: typography.fontWeightBold,
        //marginLeft: '3.5rem',
        // [breakpoints.between('md', 1200)]: {
        //     marginLeft: '6.3rem',
        // },
        // [breakpoints.down('md')]: {
        //     marginLeft: '1.79rem',
        //     marginRight: '1rem'  // Adjust this to what you find suitable for smaller screens
        // },
        [breakpoints.down('sm')]: {
            marginLeft: '10px'
        },
    },
    listItems: {
        marginLeft: '2.7rem',
        fontWeight: typography.fontWeightLight,
        '& li': {
            marginBottom: '1.25rem',
            listStyle: 'none',
            position: 'relative',
            '&::before': {
                content: "'•'",
                color: '#94004A',
                position: 'absolute',
                left: '-28px',
            },
        },
        [breakpoints.between('md', 1200)]: {
            marginLeft: '5.5rem',
        },
        [breakpoints.down('md')]: {
            marginLeft: '1rem',
            marginRight: '1rem'  // Adjust this to what you find suitable for smaller screens
        },
    },
    lastStepDisclaimer: {
        fontWeight: typography.fontWeightLight,
        [breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    },
    imageContainer: {
        width: '100%',  // this will ensure the image doesn't extend beyond its parent container
        '& img': {
            maxWidth: '100%',  // this will ensure the image doesn't extend beyond the imageContainer
        },
    },
    headerStyle: {
        color: '#000',
        textAlign: 'center',
        fontFamily: 'CircularRegular',
        fontSize: '2rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '2.5rem',
        marginBottom: '2rem',
    },
    colLeft: {
        [breakpoints.down('sm')]: { order: 2 }
    },
    colRight: {
        [breakpoints.down('sm')]: { order: 1 },
        display: 'flex',
        flexDirection: 'column',
        [breakpoints.up('md')]: {
            alignItems: 'flex-end',
            marginTop: '2.05rem',
            //marginRight: '1rem',
        },
    },

    /** Eligibility + disclaimers wrapper: sit to the right on desktop */
    eligibilityWrap: {
        marginLeft: '1rem',
        marginRight: '1rem',
        maxWidth: 604,
        [breakpoints.up('md')]: {
            marginLeft: 'auto',  // push to the right
            marginRight: 0,
        },
        [breakpoints.down('sm')]: {
            maxWidth: '100%',
        },
        '@media (max-width:1170px)': {
            paddingRight: '1.5rem',
            boxSizing: 'border-box',
        },
        '@media (max-width:1040px)': {
            paddingLeft: '1rem',
            boxSizing: 'border-box',
        },
    },
    infoBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap', // ✅ allows text to wrap under icon on mobile
        padding: 32,
        gap: 16,
        width: '100%',
        borderRadius: 20,
        boxSizing: 'border-box'
    },
    successBox: {
        background: '#FBF6EE'
    },
    failBox: {
        background: '#FBF6EE'
    },
    infoIcon: {
        width: 52,
        height: 52,
        borderRadius: 9999,
        flex: '0 0 auto',
        [breakpoints.down('sm')]: {
            width: 48,
            height: 48
        }
    },
    spinnerWrap: {
        width: 52,
        height: 52,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        willChange: 'transform',
        transform: 'translateZ(0)',
        [breakpoints.down('sm')]: {
            width: 48,
            height: 48,
        }
    },
    authSpinner: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: '12px'
    },
    textCol: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 8,
        flex: 1,
        minWidth: 0 // ✅ text will shrink nicely instead of overflowing
    },
    infoTitle: {
        fontWeight: 700,
        fontSize: 24,
        lineHeight: '24px',
        color: '#000',
        [breakpoints.down('sm')]: {
            lineHeight: '26px'
        }
    },
    infoDesc: {
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '24px',
        color: '#000'
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        marginBottom: 8,
    },
    lastStepImage: {
        width: '25rem',
        maxWidth: '100%',
        display: 'block',
        [breakpoints.down('sm')]: {
            maxWidth: '80%',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: '1.75rem',
        }
    }
})

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 560,
        backgroundColor: theme.palette.background.paper
    },
    paper: {
        width: '100%',
        borderRadius: 35,
        margin: '0px !important',
        [theme.breakpoints.down('sm')]: {
            width: '90%'
        }
    }
}))

interface InstantRentFormProps
    extends WithTranslation,
    ReduxForm,
    ApartmentInformation {
    autocompleteLocation: undefined | AutocompleteOption | string
    saveInstantRentForm: (arg: any) => any
    isDisabled: boolean
    classes: MuiClasses
    t: i18n.TFunction
    changeFormValue: (field: string, value: string) => void
    currentStep: any
    doStepBack: () => void
    isMobile: any
    waterFeeBasis: WaterFeeBasis | undefined
    beforeLogin?: boolean
    doNextStep: any
    movingWithAmount: number | DropDownItem
    contactEmail: string
    phoneNumber: string
    postalCode: string
    postalArea: string
    acceptedOnlineBanking?: boolean
}
const InstantRentForm = ({
    classes,
    t,
    handleSubmit,
    submitting,
    saveInstantRentForm,
    doStepBack,
    movingWithAmount,
    currentStep,
    isMobile,
    beforeLogin,
    isDisabled,
    doNextStep,
    contactEmail,
    phoneNumber,
    autocompleteLocation,
    postalCode,
    postalArea,
    changeFormValue,
    acceptedOnlineBanking
}: InstantRentFormProps) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const routeMatch = useRouteMatch()
    const applicationCode = (routeMatch.params as any).applicationCode
    const location = useLocation()
    const { search } = useLocation()
    //const queryParams = new URLSearchParams(location.search)
    const isNewApplication = useMemo(
        () => new URLSearchParams(search).get('newApplication') === 'true',
        [search]
    )

    const applicantCode = useMemo(() => {
        const qs = new URLSearchParams(location.search)
        return qs.get('applicant') || ''
    }, [location.search])
    //validation
    // useEffect(() => {
    //     if (
    //         [4, 5, 6, 7, 8].includes(currentStep) &&
    //         !localStorage.getItem('application')
    //     ) {
    //         history.push(`/instant-rent/${applicationCode}/steps/1`)
    //     }
    // })

    useEffect(() => {
        if (localStorage.getItem('authInfo') !== undefined) {
            const { language, movingWithAmount } = JSON.parse(
                localStorage.getItem('authInfo') || '[]'
            )
            dispatch(change('InstantRentForm', 'movingWithAmount', movingWithAmount))
            dispatch(change('InstantRentForm', 'applicationCode', applicationCode))
            dispatch(change('InstantRentForm', 'language', language))
        }
    }, [])

    const [isEmpty, setIsEmpty] = useState(false)
    // const [checkStepOnw, setCheckStepOnw] = useState(true)
    //const [appResponse, setAppResponse] = useState(null) as any
    // const [applicantCreditStatus, setApplicantCreditStatus] = useState(false)
    const [authenticationError, setAuthenticationError] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [isAuthLoading, setAuthLoading] = useState(false)
    const [newRentDialog, setNewRentDialog] = useState(null) as any
    //const [rentedDialog, setRentedDialog] = useState(null) as any
    const [open, setOpen] = useState(true)
    //const [acceptDraftCheck, setAcceptDraftCheck] = useState(false)
    //const [isTour, setTour] = useState(false)
    //onst [isPaymentStatus, setPaymentStatus] = useState(null) as any
    //const [failedPaymentModal, setFailedPaymentModal] = useState(true)
    //const [isLoadingPDF, setIsLoadingPDF] = useState(false)
    const [application, setApplication] = useState(null)
    const [duplicateAuthentication, setDuplicateAuthentication] = useState(false)
    // isApartment,
    // const [setApartment] = useState(null) as any
    const [email, setEmail] = useState('');
    const [showEmailForm, setShowEmailForm] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [emailValidationError, setEmailValidationError] = useState(false);
    //const [addFinancialInfoLoading, setAddFinancialInfoLoading] = useState(false);

    const dialogClasses = useStyles()
    const url = new URL(window.location.href)
    const [isSecondary, setIsSecondary] = useState(false);
    const [secondaryStatusReady, setSecondaryStatusReady] = useState(false);
    const [digivakuusHandled, setDigivakuusHandled] = useState(false)
    const [eligibilityLoading, setEligibilityLoading] = useState(false)
    const [eligibilityResult, setEligibilityResult] = useState<null | boolean>(null)
    const [acceptedDigivakuus, setAcceptedDigivakuus] = useState(false)

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();

    useEffect(() => {
        const isSecondaryFromQuery = query.get('secondary') === 'true';

        const storedItem = localStorage.getItem('secondary');
        let secondaryValue = false;

        if (storedItem) {
            const { value, expiry } = JSON.parse(storedItem);
            if (new Date().getTime() < expiry) {
                secondaryValue = value;
            } else {
                localStorage.removeItem('secondary');
            }
        }

        if (isSecondaryFromQuery) {
            const expiryTime = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
            const item = { value: true, expiry: expiryTime };
            localStorage.setItem('secondary', JSON.stringify(item));
            secondaryValue = true;
        }

        setIsSecondary(secondaryValue)
        setSecondaryStatusReady(true)
    }, []);

    useEffect(() => {
        if (currentStep !== 2 || !secondaryStatusReady || isSecondary) return

        const storedApplication = localStorage.getItem('application')
        if (!storedApplication) return

        const hasEmailValue = typeof contactEmail === 'string' ? contactEmail.trim().length > 0 : Boolean(contactEmail)
        const hasPhoneValue = typeof phoneNumber === 'string' ? phoneNumber.trim().length > 0 : Boolean(phoneNumber)

        try {
            const parsedApplication = JSON.parse(storedApplication)

            const sanitizeEmail = (value: unknown): string => (typeof value === 'string' ? value.trim() : '')
            const normalizePhone = (value: unknown): string => {
                if (typeof value !== 'string') return ''
                const digitsOnly = value.replace(/[^\d]/g, '')
                if (!digitsOnly) return ''
                return `+${digitsOnly}`
            }

            const emailFromStorage = sanitizeEmail(parsedApplication?.data?.email)
            const phoneFromStorage = normalizePhone(parsedApplication?.data?.phone)

            if (emailFromStorage && !hasEmailValue) {
                dispatch(change('InstantRentForm', 'contactEmail', emailFromStorage))
            }

            if (phoneFromStorage && !hasPhoneValue) {
                dispatch(change('InstantRentForm', 'phoneNumber', phoneFromStorage))
            }
        } catch (error) {
            console.error('Failed to prefill contact details from storage', error)
        }
    }, [currentStep, isSecondary, secondaryStatusReady, contactEmail, phoneNumber, dispatch])

    useEffect(() => {
        if (isNewApplication) {
            const expiryTime = new Date().getTime() + 45 * 60 * 1000 // 45 mins
            const item = { value: true, expiry: expiryTime }
            localStorage.setItem(`newApplication_${applicationCode}`, JSON.stringify(item))
        }
    }, [isNewApplication, applicationCode])

    useEffect(() => {
        const storedApartment = localStorage.getItem('apartment')
        if (storedApartment) {
            try {
                JSON.parse(storedApartment)
            } catch (error) {
                console.warn('Failed to parse stored apartment, clearing cache', error)
                localStorage.removeItem('apartment')
            }
        }

        let mounted = true

        const redirectHome = (messageKey: string) => {
            alert(t(messageKey))
            setTimeout(() => {
                window.location.href = 'https://leea.fi/'
            }, 0)
        }

        const fetchApartment = async () => {
            try {
                const data = await ShowingsApi.getForRentapp(applicationCode)
                if (!mounted) return
                const apartmentData = data?.apartment
                if (apartmentData) {
                    localStorage.setItem('apartment', JSON.stringify(apartmentData))
                    if (apartmentData.status === 'rented') {
                        redirectHome('instantRent.apartmentRented')
                    }
                }
            } catch (error) {
                if (!mounted) return
                redirectHome('instantRent.generalError')
            }
        }

        fetchApartment()

        return () => {
            mounted = false
        }
    }, [applicationCode, t])


    useEffect(() => {
        if (currentStep !== 4 || digivakuusHandled) return
        const params = new URLSearchParams(search)
        if (params.get('digivakuusCheck') === 'success') {
            onDigivakuusCheckSuccess()
            setDigivakuusHandled(true)
        }
    }, [currentStep, search, digivakuusHandled])

    useEffect(() => {
        if (currentStep !== 4) return
        console.log('checking digivakuus params');

        const params = new URLSearchParams(search)
        const ok = params.get('digivakuusCheck') === 'success'
        const applicant = params.get('applicant') || ''
        if (!ok || !applicant) return
        startDelayedDigivakuusCheck()
    }, [currentStep, digivakuusHandled, search])

    useEffect(() => {
        if (!applicantCode) return
        const stored = localStorage.getItem(`digivakuusAccepted_${applicantCode}`)
        if (stored !== null) {
            setAcceptedDigivakuus(JSON.parse(stored))
        }
    }, [applicantCode])

    const onDigivakuusCheckSuccess = async () => {
        await Api.checkDigivakuusEligibility({ applicationCode, applicantCode })
    }

    const navigateTo = useCallback(
        (newStep) => {
            history.push(`/aftershowing/${applicationCode}/steps/${newStep}`)
        },
        [history, routeMatch]
    )

    const setStorageItem = (application: any, name = 'application') => {
        localStorage.setItem(name, JSON.stringify(application))
    }

    const getStorageItem = (name = 'application'): any => {
        return JSON.parse(localStorage.getItem(name) || '{}')
    }

    const validateApplicantAuthDataSaved = async () => {
        const status = url.searchParams.get('status')
        //console.log(status);

        if (!status) {
            return
        }

        if (status == 'duplicate') {
            setDuplicateAuthentication(true)
            setAuthenticationError(true)
            return
        }

        if (status !== 'success') {
            setDuplicateAuthentication(false)
            setAuthenticationError(true)
            return
        }

        setLoading(true)

        await Api.getApplicationByCode(`${applicationCode}`)
            .then((response: any) => {
                //setAppResponse(response)
                setStorageItem(response)
                if (response.applicants && response.applicants.every(applicant => applicant.authData)) {
                    navigateTo(2)
                    //tämä local storagen avulla?
                    //  setApplicantCreditStatus(false)
                    setLoading(false)
                } else {
                    setAuthenticationError(true)
                    setLoading(false)
                    return
                    //TÄHÄN JOTAIN MESSAGEA?
                    //PITÄÄ TEHDÄ UUSI HAKEMUS?
                    //  setApplicantCreditStatus(true)
                    //CLEAR APPLICANTS NAPPI?
                }
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    //restart application
    const handleRestartApplication = () => {
        setOpen(false)
        localStorage.clear()
        navigateTo(1)
    }

    // Add new Tenant
    const addNewTenant = () => {
        //setOpen(false)
        //navigateTo(2)
        setEmailSent(false)
        setShowEmailForm(true);
    }

    const handleSendEmail = async () => {
        try {
            setEmailSent(false);
            setEmailError(false);
            setEmailValidationError(false);

            if (!email || validateEmail(email)) {
                setEmailValidationError(true);
                return
            }

            const response = await Api.sendAfterShowingMail(email, applicationCode);

            if (response.status !== 200) {
                setEmailError(true)
                return
            }

            setEmailSent(true)
            setShowEmailForm(false)
            setEmail('')
        } catch (error) {
            //console.error('Error sending email:', error);
            setEmailError(true);
        }
    };
    const handleFormEvent = () => {
        const formattedAddress =
            typeof autocompleteLocation === 'string'
                ? autocompleteLocation.trim()
                : (autocompleteLocation?.label || '').trim()
        const isContactEmailValid = !required(contactEmail) && !noSpaceValue(contactEmail) && !validateEmail(contactEmail);
        const isPhoneNumberValid = !required(phoneNumber) && !noSpacesPhoneNum(phoneNumber) && !validatePhoneNumber(phoneNumber);
        const isPostalAreaValid = !requiredLocation(postalArea) && !isInvalidCharacters(postalArea);
        const isPostalCodeValid = !required(postalCode) && !isPostalCode(postalCode) && !isInvalidCharacters(postalCode);
        const isAutocompleteLocationValid = !requiredLocation(autocompleteLocation) && !isInvalidCharacters(formattedAddress);

        if (
            contactEmail &&
            isContactEmailValid &&
            phoneNumber &&
            isPhoneNumberValid &&
            formattedAddress &&
            isAutocompleteLocationValid &&
            postalCode &&
            isPostalCodeValid &&
            postalArea &&
            isPostalAreaValid
        ) {
            setIsEmpty(false)
            setLoading(true)

            const { code = '', ...application } = getStorageItem()

            //applicants status=created before updateInfo (step4)
            const applicant = application?.applicants?.find(
                (x: { status: string }) => x.status === 'created'
            )

            const stored = localStorage.getItem(`newApplication_${applicationCode}`)
            let newApplicationFlag = false

            if (stored) {
                const { value, expiry } = JSON.parse(stored)
                if (new Date().getTime() < expiry) {
                    newApplicationFlag = value
                    // 💥 delete immediately after use
                    localStorage.removeItem(`newApplication_${applicationCode}`)
                } else {
                    localStorage.removeItem(`newApplication_${applicationCode}`) // expired
                }
            }

            Api.updateAfterShowingApplication({
                applicationCode,
                applicantCode: applicant?.code,
                email: contactEmail,
                phone: phoneNumber,
                address: formattedAddress,
                postalCode,
                postalArea,
                isNewApplication: newApplicationFlag
            })
                .then((response) => {
                    setStorageItem(response)
                    history.push(`/aftershowing/${applicationCode}/steps/3?applicant=${encodeURIComponent(applicant?.code || '')}`)
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false)
                })
        } else {
            setIsEmpty(true)
            setLoading(false)
        }
    }

    const startCreditScoreAuth = () => {
        if (isAuthLoading) return

        setIsEmpty(false)
        setAuthLoading(true)

        Api.initiateAuthorizationForCreditScore({
            applicationCode: applicationCode,
        })
            .then((response) => {
                window.location.href = response.authenticationUrl;
                // setStorageItem(response)
                // setNewRentDialog(response)
                //navigateTo(5)
            })
            .catch((error) => {
                setAuthLoading(false)
                setLoading(false)
            })
    }

    const declineApartment = useCallback(async () => {
        if (isLoading) return

        setLoading(true)
        navigateTo(0)

        try {
            await ApplicationsApi.updateApplicationStatusByCode(applicationCode, {
                status: ApplicationStatus.notInterested
            })
        } catch (error) {
            console.error('Failed to delete application', error)
        } finally {
            setLoading(false)
        }
    }, [applicationCode, isLoading, navigateTo])

    const goToReserveView = (applicationCode: string) => {
        window.location.href = `/reserve/${applicationCode}`
    }

    const noAdditionalApplicants = () => {
        //localStorage.removeItem('secondary');
        setOpen(false)
        setNewRentDialog(null)
    };

    const resetNotInterested = async () => {
        setLoading(true)
        await ApplicationsApi.updateApplicationStatusByCode(applicationCode, {
            status: ApplicationStatus.created
        });
        setLoading(false)
        navigateTo(1)
    }

    // const addFinancialInfo = async () => {
    //     setAddFinancialInfoLoading(true)
    //     try {
    //         const response = await ApplicationsApi.addFinancialInfo(applicationCode)

    //         if (response?.sessionUrl) {
    //             window.location.href = response.sessionUrl
    //         } else {
    //             console.error('No sessionUrl returned from API')
    //         }
    //     } catch (error) {
    //         console.error('Error during Monthio session initiation:', error)
    //     }
    // }

    useEffect(() => {
        if (currentStep === 1) {
            validateApplicantAuthDataSaved()
        }
    }, [currentStep])

    useEffect(() => {
        if (currentStep === 1 && acceptedOnlineBanking) {
            setIsEmpty(false)
        }
    }, [acceptedOnlineBanking, currentStep])

    useEffect(() => {
        const fetchApplication = async () => {
            if (!application) {
                setLoading(true)
                try {
                    const applicationResponse = await Api.getApplicationByCode(`${applicationCode}`);
                    setApplication(applicationResponse)
                    setStorageItem(applicationResponse)

                    const applicationData = JSON.parse(localStorage.getItem(applicationResponse.applicationId) || '{}');
                    if (applicationData && applicationData.processCompleted) {
                        navigateTo(4);
                        return;
                    }

                    if (applicationResponse.status == ApplicationStatus.notInterested) {
                        navigateTo(0)
                    }
                    if (applicationResponse.status == ApplicationStatus.wantsContract) {
                        //navigateTo(4)
                    }
                    if (applicationResponse.status == ApplicationStatus.created && (currentStep === 0 || currentStep > 2)) {
                        // navigateTo(1)
                    }

                } catch (error) {
                }
                setLoading(false)
            }
        };

        fetchApplication();
    }, []);

    useEffect(() => {
        if (currentStep !== 4) return

        if (!isSecondary) {
            setNewRentDialog({ show: true })
            setOpen(true)
        } else {
            // secondary mode => ensure dialog is NOT shown
            setOpen(false)
            setNewRentDialog(null)
            localStorage.removeItem('secondary');
        }
    }, [currentStep, isSecondary])


    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, [location.pathname])

    const handleSubmitCustom = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
    };

    const startDelayedDigivakuusCheck = useCallback(() => {
        const params = new URLSearchParams(search)
        const ok = params.get('digivakuusCheck') === 'success'
        const applicant = params.get('applicant') || applicantCode || ''
        if (!ok || !applicant) return

        const resultKey = `digivakuus_result_${applicationCode}_${applicant}`
        const tsKey = `digivakuus_ts_${applicationCode}_${applicant}`

        // 🔹 If we already have a stored eligibility result, use it
        const storedResult = localStorage.getItem(resultKey)
        if (storedResult !== null) {
            setEligibilityResult(storedResult === 'true')
            setEligibilityLoading(false)
            return
        }

        // 🔹 If we have it in current state, save it and use it
        const existing = application?.applicants?.find(a => a.code === applicant)
        if (typeof existing?.digivakuusEligibility === 'boolean') {
            setEligibilityResult(existing.digivakuusEligibility)
            localStorage.setItem(resultKey, String(existing.digivakuusEligibility))
            setEligibilityLoading(false)
            return
        }

        // 🔹 Otherwise, schedule API check with delay
        const now = Date.now()
        const storedTs = localStorage.getItem(tsKey)
        const firstTs = Number(storedTs || '0') || now
        if (!storedTs) localStorage.setItem(tsKey, String(firstTs))

        const targetDelay = 55_000
        const elapsed = now - firstTs
        const remaining = Math.max(0, targetDelay - elapsed)

        setEligibilityLoading(true)
        setEligibilityResult(null)

        const run = async () => {
            try {
                const res = await Api.getApplicationByCode(`${applicationCode}`)
                const updatedApplicant = res?.applicants?.find(a => a.code === applicant)
                const eligibility = Boolean(updatedApplicant?.digivakuusEligibility)
                setEligibilityResult(eligibility)
                localStorage.setItem(resultKey, String(eligibility))
            } catch (e) {
                setEligibilityResult(false)
                localStorage.setItem(resultKey, 'false')
            } finally {
                setEligibilityLoading(false)
                localStorage.removeItem(tsKey)
            }
        }

        if (remaining === 0) run()
        else setTimeout(run, remaining)
    }, [search, applicationCode, applicantCode, application])

    return (
        <form onSubmit={handleSubmitCustom}>
            <Grid container>
                {' '}
                {currentStep === 0 && (
                    <>
                        {isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <>

                                <Grid container className={`${classes.acceptedDeclinedFormContainer} ${classes.formContainer}`}>
                                    <Grid item xs={12} md={5}>
                                        <img src={phoneAndHouse} alt="PhoneAndHouse" style={{
                                            width: '30rem',
                                            maxWidth: '100%'
                                        }} />
                                    </Grid>
                                    <Grid item xs={12} md={7}>
                                        <Typography variant="body1" className={classes.acceptedDeclinedText}>
                                            {t('afterShowing.declined')}
                                        </Typography>
                                        <Typography variant="body1" component="ul" className={classes.listItems}>
                                            <li>{t('afterShowing.declinedDisclaimer1')}</li>
                                            {/* <li>{t('afterShowing.declinedDisclaimer2')}</li>
                                                <li>{t('afterShowing.declinedDisclaimer3')}</li>
                                                <li>{t('afterShowing.declinedDisclaimer4')}</li> */}
                                        </Typography>
                                    </Grid>

                                    <Button
                                        fullWidth
                                        color='primary'
                                        className={`${classes.responsiveButton}`}
                                        style={{
                                            boxShadow: '0px 0px 10px rgb(0 0 0 / 20%)',
                                            marginTop: '3rem', borderRadius: '10px'
                                        }}
                                        onClick={resetNotInterested}
                                    >
                                        <Typography variant='h6' style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                                            {t('afterShowing.changedMind')}
                                        </Typography>
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </>
                )}
                {currentStep === 1 && (
                    <>
                        {submitting === true || isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <Grid container className={classes.formContainer}>
                                <Grid xs={12}>
                                    <Grid container xs={12} md={12} className={classes.marginAuto}>
                                        {' '}
                                        <Grid item xs={12} className={classes.responsiveWidth}>
                                            <Grid item xs={12}>
                                                <div className={classes.headerStyle}>
                                                    {t('instantRent.onlineBankingCredentialsTitle')}
                                                </div>
                                                <Typography
                                                    variant='body1'
                                                    className={classes.authDesc}
                                                >
                                                    <pre className='MuiTypography-root MuiTypography-body1'>
                                                        {t('instantRent.onlineBankingCredentialsDesc')}
                                                    </pre>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    className={classes.consentCheckbox}
                                                    style={{ marginRight: '0px', marginLeft: '0px' }}
                                                    control={
                                                        <Field
                                                            name='acceptedOnlineBanking'
                                                            component={ReduxCheckbox}
                                                        />
                                                    }
                                                    label={
                                                        <div>
                                                            {t('instantRent.onlineBankingCredentialsCheckboxLabel')}
                                                        </div>
                                                    }
                                                />
                                            </Grid>
                                            {isEmpty && currentStep === 1 && (
                                                <Typography className={classes.consentError} variant='body1'>
                                                    {t('afterShowing.mandatoryField')}
                                                </Typography>
                                            )}
                                            <Grid item xs={12}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <button
                                                    style={{
                                                        background: 'transparent',
                                                        border: 'none',
                                                        width: '100%',
                                                        marginLeft: '-4px',
                                                        marginRight: '-4px',
                                                    }}
                                                    type='submit'
                                                    disabled={isDisabled || isAuthLoading}
                                                >
                                                    <StartAuthTrigger
                                                        suggestContainerStyle={classes.authPrompt}
                                                        hideSuggestIcon
                                                        renderText={() => (
                                                            <Grid
                                                                container
                                                                justify='center'
                                                                alignItems='center'
                                                                direction={isMobile ? 'column' : 'row'}
                                                            >
                                                                <Grid
                                                                    item
                                                                    className={isMobile ? `${classes.mb6}` : ''}
                                                                >
                                                                    <img src={OutlineLockPersonIcon} />
                                                                </Grid>
                                                                <Grid item>
                                                                    <Typography
                                                                        variant='h6'
                                                                        className={`${classes.centeredText} ${classes.boldText}`}
                                                                    >
                                                                        {t('instantRent.startAuthentication')}
                                                                    </Typography>
                                                                </Grid>
                                                                {isAuthLoading && (
                                                                    <Grid item className={classes.authSpinner}>
                                                                        <CircularProgress size={24} style={{ color: '#94004A' }} />
                                                                    </Grid>
                                                                )}
                                                            </Grid>
                                                        )}
                                                        isModal
                                                        customSuggestTextStyles={`${classes.customSuggestTextStyles} ${classes.centeredText}`}
                                                        doNextStep={startCreditScoreAuth}
                                                        submit
                                                        setIsEmpty={setIsEmpty}
                                                        beforeLogin={beforeLogin}
                                                        toValidate={{
                                                            acceptedOnlineBanking
                                                        }}
                                                    />
                                                </button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {isNewApplication ? (
                                                    <Button
                                                        type='button'
                                                        className={`${classes.skipIdentificationButton}`}
                                                        onClick={() => goToReserveView(applicationCode)}
                                                        disabled={isLoading || isAuthLoading}
                                                    >
                                                            {t('afterShowing.goToReserveView')}
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        type='button'
                                                        className={`${classes.skipIdentificationButton}`}
                                                        onClick={declineApartment}
                                                        disabled={isLoading || isAuthLoading}
                                                    >
                                                            {t('afterShowing.declineApartment')}
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>
                                        {/* <CircularProgress color='inherit' /> */}
                                        {/* <Grid
                                            className={classes.responsiveWidth}
                                            container
                                            direction={isMobile ? 'column' : 'column-reverse'}
                                        >
                                            <Grid
                                                container
                                                direction={isMobile ? 'column-reverse' : 'column'}
                                                className={classes.buttons}
                                                alignItems='center'
                                            >
                                                <Grid item className={classes.fullWidth}>
                                                    <BackButton
                                                        currentStep={currentStep}
                                                        classes={classes}
                                                        doStepBack={doStepBack}
                                                        customStyle={`${classes.shadowSecondaryButton} ${classes.mBottom}`}
                                                    />
                                                </Grid>
                                                {/* <Grid item className={classes.fullWidth}>
                                                    <Dialog
                                                        dialogId='UpdateStatusToCancelled'
                                                        disabled={false}
                                                        buttonLabel={t(
                                                            'instantRent.buttonLabels.stopRenting'
                                                        )}
                                                        buttonFullWidth
                                                        confirmDialogSubmitAction={() =>
                                                            console.log('confirm2')
                                                        }
                                                        buttonClassName={`${classes.cancelTextButton}`}
                                                        hideCloseIcon
                                                        className={classes.dialogContanier}
                                                        borderRadius={'35px'}
                                                        confirmLabel={t(
                                                            'instantRent.buttonLabels.continueRenting'
                                                        )}
                                                        customButtonContainerDirection={'column-reverse'}
                                                        customButtonContainerClassName={
                                                            classes.centeredText
                                                        }
                                                        buttonContainerStyles={classes.mb14}
                                                        customButtonConfirmClassName={
                                                            classes.modalPrimaryButton
                                                        }
                                                        customButtonCloseClassName={
                                                            classes.modalSecondaryButton
                                                        }
                                                        closeLabel={t(
                                                            'instantRent.buttonLabels.stopRenting'
                                                        )}
                                                        beforeCloseDialogAction={cancelApplication}
                                                        Content={
                                                            <TerminationOfTenancyModal
                                                                classes={classes}
                                                                t={t}
                                                            />
                                                        }
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid> */}
                                    </Grid>
                                </Grid>
                                {/* suspended rental alert */}
                                {authenticationError ===
                                    true /* authentication failure alert */ && (
                                        <div className={dialogClasses.root}>
                                            <ConfirmationDialogRaw
                                                maxWidth='sm'
                                                classes={{
                                                    paper: dialogClasses.paper
                                                }}
                                                keepMounted
                                                open={open}
                                            >
                                                <Box className={classes.authPop}>
                                                    <Box
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            marginBottom: 20
                                                        }}
                                                    >
                                                        <CancelIcon size='5em' color='#D43838' />
                                                    </Box>
                                                    <Typography
                                                        style={{ maxWidth: 300, margin: 'auto' }}
                                                        align='center'
                                                        variant='h5'
                                                    >
                                                        {t('instantRent.authenticationFailedTitle')}
                                                    </Typography>
                                                    <Box
                                                        style={{
                                                            paddingTop: 20,
                                                            paddingBottom: 20
                                                        }}
                                                    >
                                                        <Typography align='center' variant='h6'>
                                                            {duplicateAuthentication ?
                                                                t('instantRent.authenticationFailedDuplicateDescription') :
                                                                t('instantRent.authenticationFailedDescription')}
                                                        </Typography>
                                                    </Box>
                                                    <Button
                                                        fullWidth
                                                        variant='contained'
                                                        color='primary'
                                                        className={`${classes.responsiveButton}`}
                                                        onClick={handleRestartApplication}
                                                    >
                                                        <Typography variant='h6'>
                                                            {t('instantRent.buttonLabels.tryAgain')}
                                                        </Typography>
                                                    </Button>
                                                </Box>
                                            </ConfirmationDialogRaw>
                                        </div>
                                    )}
                                {/* {applicantCreditStatus === true && (
                                    <div className={dialogClasses.root}>
                                        <ConfirmationDialogRaw
                                            maxWidth='sm'
                                            classes={{
                                                paper: dialogClasses.paper
                                            }}
                                            keepMounted
                                            open={open}
                                        >
                                            <Box className={classes.authPop}>
                                                <Box
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginBottom: 20
                                                    }}
                                                >
                                                    <CancelIcon size='5em' color='#D43838' />
                                                </Box>
                                                <Typography
                                                    style={{ maxWidth: 300, margin: 'auto' }}
                                                    align='center'
                                                    variant='h5'
                                                >
                                                    {t('instantRent.rentalSuspendedTitle')}
                                                </Typography>
                                                <Box
                                                    style={{
                                                        paddingTop: 20,
                                                        paddingBottom: 20
                                                    }}
                                                >
                                                    <Typography align='center' variant='h6'>
                                                        {t('instantRent.rentalSuspendedDiscription')}
                                                    </Typography>
                                                </Box>
                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    color='primary'
                                                    className={`${classes.responsiveButton}`}
                                                    onClick={handleRestartApplication}
                                                >
                                                    <Typography variant='h6'>
                                                        {t('instantRent.buttonLabels.tryAgain')}
                                                    </Typography>
                                                </Button>
                                            </Box>
                                        </ConfirmationDialogRaw>
                                    </div>
                                )} */}
                            </Grid>
                        )}
                    </>

                )}

                {/* change this back to 3 */}
                {currentStep === 2 && (
                    <>
                        {isLoading === true ? (
                            <LoadingContainer />
                        ) : (
                            <Grid container className={classes.formContainer}>
                                <Grid xs={12}>
                                    <Grid container xs={12} md={12} className={classes.marginAuto}>
                                        {' '}
                                        <Grid item xs={12} className={classes.responsiveWidth}>
                                            <Grid item xs={12} style={{ textAlign: 'center' }}> {/* Center content */}
                                                <div className={classes.headerStyle}>
                                                    {t('instantRent.applicantInfoFormTitle')}
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} style={{ textAlign: 'center', marginTop: '20px' }}> {/* Center content and add space */}
                                                <Typography
                                                    className={`${classes.heading}`}
                                                >
                                                    {t('afterShowing.applicantInfoFormDisclaimer')}
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                container
                                                spacing={4}
                                                className={classes.containerItem}
                                            >
                                                <Grid item xs={12} md={6}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.email')}:
                                                    </Typography>
                                                    <ReduxFormField
                                                        autoComplete='username'
                                                        name='contactEmail'
                                                        component={MyInput}
                                                        style={{
                                                            width: '100%',
                                                            height: '58px',
                                                            padding: '20px',
                                                            background: '#E7ECEF'
                                                        }}
                                                        validate={[required, noSpaceValue, validateEmail]}
                                                        required
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.phone')}:
                                                    </Typography>
                                                    <ReduxFormField
                                                        autoComplete='tel'
                                                        name='phoneNumber'
                                                        component={MyInput}
                                                        style={{
                                                            width: '100%',
                                                            height: '58px',
                                                            padding: '20px',
                                                            background: '#E7ECEF'
                                                        }}
                                                        validate={[
                                                            required,
                                                            noSpacesPhoneNum,
                                                            validatePhoneNumber
                                                        ]}
                                                        required
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                spacing={4}
                                                className={classes.containerItem}
                                            >
                                                <Grid item xs={12} sm={12}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.address')}:
                                                    </Typography>

                                                    <Field
                                                        name='autocompleteLocation'
                                                        component={ReduxGoogleAutocomplete}
                                                        selectLabel={t('autocomplete.select')}
                                                        existingLocations={[]}
                                                        placeholder={t('afterShowing.autocompletePlaceholder')}
                                                        changeFormValue={changeFormValue}
                                                        validate={[required]}
                                                        required
                                                        normalize={(val: any) =>
                                                            typeof val === 'string'
                                                                ? val.replace(/^\s+/, '')
                                                                : val
                                                        }
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                spacing={4}
                                                className={classes.containerItem}
                                            >
                                                <Grid item xs={12} md={6}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.postalCode')}:
                                                    </Typography>
                                                    <ReduxFormField
                                                        name='postalCode'
                                                        normalize={onlyNums}
                                                        min={0}
                                                        validate={[
                                                            required,
                                                            isPostalCode,
                                                            isInvalidCharacters
                                                        ]}
                                                        required
                                                        component={MyInput}
                                                        style={{
                                                            width: '100%',
                                                            height: '58px',
                                                            padding: '20px',
                                                            background: '#E7ECEF'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Typography
                                                        variant='body1'
                                                        gutterBottom
                                                        className={`${classes.requiredField} ${classes.formLabel}`}
                                                    >
                                                        {t('instantRent.applicant.place')}:
                                                    </Typography>

                                                    <ReduxFormField
                                                        name='postalArea'
                                                        normalize={charsSpace}
                                                        component={MyInput}
                                                        style={{
                                                            width: '100%',
                                                            height: '58px',
                                                            padding: '20px',
                                                            background: '#E7ECEF'
                                                        }}
                                                        validate={[required, isInvalidCharacters]}
                                                        required
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                direction={isMobile ? 'column' : 'column-reverse'}
                                            >
                                                <Grid
                                                    container
                                                    direction={isMobile ? 'column-reverse' : 'column'}
                                                    className={classes.buttons}
                                                    alignItems='center'
                                                        style={{ boxSizing: 'content-box' }}
                                                >
                                                    {isEmpty && (
                                                        <Typography
                                                            align='center'
                                                            style={{ color: 'red', width: '100%', marginBottom: 16 }}
                                                            variant='body1'
                                                        >
                                                            {t('apartment.actions.stepFail')}
                                                        </Typography>
                                                    )}
                                                    <Grid item className={classes.fullWidth}>
                                                        {/* <NextStepButton
                          customStyles={classes.primaryBtn}
                          classes={classes}
                          beforeLogin={beforeLogin}
                          setIsEmpty={setIsEmpty}
                        /> */}
                                                        {/* <NextStepButton
                            classes={classes}
                            setIsEmpty={setIsEmpty}
                            disabled={isDisabled}
                            beforeLogin={beforeLogin}
                            toValidate={{
                              contactEmail,
                              phoneNumber,
                              autocompleteLocation,
                              postalCode,
                              postalArea
                            }}
                          /> */}
                                                        <Button
                                                            // disabled={isChecked}
                                                            fullWidth
                                                            variant='contained'
                                                            color='primary'
                                                            className={`${classes.responsiveButton} ${classes.fullWidthActionButtonNext}`}
                                                            onClick={handleFormEvent}
                                                        >
                                                            <Grid
                                                                container
                                                                justify='center'
                                                                alignItems='center'
                                                            >
                                                                <Grid item>{t('general.next')}</Grid>
                                                                <Grid item className={classes.rightFloatingIcon}>
                                                                    <ChevronRightIcon color='#D8DCDF' />
                                                                </Grid>
                                                            </Grid>
                                                        </Button>
                                                    </Grid>
                                                    {/* <Grid item className={classes.fullWidth}>
                                                        <Dialog
                                                            dialogId='UpdateStatusToCancelled'
                                                            disabled={false}
                                                            buttonLabel={t(
                                                                'instantRent.buttonLabels.stopRenting'
                                                            )}
                                                            buttonFullWidth
                                                            confirmDialogSubmitAction={() =>
                                                                console.log('confirm3')
                                                            }
                                                            buttonClassName={`${classes.cancelTextButton}`}
                                                            hideCloseIcon
                                                            className={classes.dialogContanier}
                                                            borderRadius={'35px'}
                                                            confirmLabel={t(
                                                                'instantRent.buttonLabels.continueRenting'
                                                            )}
                                                            customButtonContainerDirection={'column-reverse'}
                                                            customButtonContainerClassName={
                                                                classes.centeredText
                                                            }
                                                            buttonContainerStyles={classes.mb14}
                                                            customButtonConfirmClassName={
                                                                classes.modalPrimaryButton
                                                            }
                                                            customButtonCloseClassName={
                                                                classes.modalSecondaryButton
                                                            }
                                                            closeLabel={t(
                                                                'instantRent.buttonLabels.stopRenting'
                                                            )}
                                                            beforeCloseDialogAction={cancelApplication}
                                                            Content={
                                                                <TerminationOfTenancyModal
                                                                    classes={classes}
                                                                    t={t}
                                                                />
                                                            }
                                                        />
                                                    </Grid> */}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </>
                )}
                {currentStep === 3 && (
                    <ApplicantDepositVerificator classes={classes} />
                )}
                {currentStep === 4 && (
                    <Grid container className={`${classes.acceptedDeclinedFormContainer} ${classes.formContainer} ${classes.step5Row}`}>
                        <Grid item xs={12} md={5} className={classes.colLeft}>
                            <img src={loginImage} alt="PhoneAndHouse" className={classes.lastStepImage}></img>
                        </Grid>

                        <Grid item xs={12} md={7} className={classes.colRight}>

                            <div className={classes.eligibilityWrap}>
                                {acceptedDigivakuus && (
                                    <>
                                        {eligibilityLoading && (
                                            <div className={`${classes.infoBox} ${classes.successBox}`} style={{ marginBottom: '1.25rem' }}>
                                                <div className={classes.titleRow}>
                                                    <div className={classes.spinnerWrap}>
                                                        <CircularProgress size={40} style={{ color: '#94004A' }} />
                                                    </div>
                                                    <Typography className={classes.infoTitle}>
                                                        {t('afterShowing.eligibilityLoading')}
                                                    </Typography>
                                                </div>
                                                <Typography className={classes.infoDesc}>
                                                    {t('afterShowing.eligibilityLoadingBody')}
                                                </Typography>
                                            </div>
                                        )}

                                        {!eligibilityLoading && eligibilityResult !== null && (
                                            <div className={`${classes.infoBox} ${eligibilityResult ? classes.successBox : classes.failBox}`} style={{ marginBottom: '1.25rem' }}>
                                                <div className={classes.titleRow}>
                                                    <img
                                                        src={eligibilityResult ? digivakuusEligible : notDigivakuusEligible}
                                                        className={classes.infoIcon}
                                                        alt=''
                                                    />
                                                    <Typography className={classes.infoTitle}>
                                                        {eligibilityResult ? t('afterShowing.eligibilityHeaderTrue') : t('afterShowing.eligibilityHeaderFalse')}
                                                    </Typography>
                                                </div>
                                                <Typography className={classes.infoDesc}>
                                                    {eligibilityResult ? t('afterShowing.eligibilityDescTrue') : t('afterShowing.eligibilityDescFalse')}
                                                </Typography>
                                            </div>
                                        )}

                                    </>
                                )}
                                <Typography variant='body1' className={classes.acceptedDeclinedTextLastStep}>
                                    {t('afterShowing.accepted')}
                                </Typography>
                                <Typography variant='body1' className={classes.lastStepDisclaimer}>
                                    {t('afterShowing.acceptedDisclaimer1')}
                                </Typography>

                            </div>

                            {/* {application?.applicants?.length > (application?.budgetInformation?.filter(b => b.status === 'Finished')?.length || 0) && (
                            <Button
                                fullWidth
                                color="primary"
                                variant={showEmailForm ? 'outlined' : 'contained'}
                                className={`${classes.responsiveButton}`}
                                onClick={() => addFinancialInfo()}
                                disabled={addFinancialInfoLoading}
                            >
                                <Typography variant="h6" style={{
                                    display: 'flex', alignItems: 'center', gap: 8
                                }}>
                                    {addFinancialInfoLoading ? (
                                        <CircularProgress size={27} style={{ color: '#94004A' }} />
                                    ) : (
                                        (application?.budgetInformation?.filter(b => b.status === 'Finished')?.length || 0) === 1
                                            ? t('afterShowing.addAdditionalApplicantFinancialInfo')
                                            : t('afterShowing.addFinancialInfo')
                                    )}
                                </Typography>
                            </Button>
                        )}*/}
                            {newRentDialog !== null ? (
                                <>
                                    <div className={dialogClasses.root}>
                                        <ConfirmationDialogRaw
                                            maxWidth="sm"
                                            classes={{
                                                paper: dialogClasses.paper
                                            }}
                                            keepMounted
                                            open={open}
                                        >
                                            <Box className={classes.addNewTenantStyles}>
                                                <Typography
                                                    style={{ maxWidth: 300, margin: 'auto' }}
                                                    align="center"
                                                    variant="h5"
                                                >
                                                    {t('instantRent.doYouWantToAdd')}
                                                </Typography>
                                                <Box
                                                    className={classes.addNewTenantDetailsStyle}
                                                    mt={4}
                                                    mb={4}
                                                >
                                                    <img
                                                        src={suggestIcon}
                                                        className={classes.suggestIcon}
                                                        alt={'Suggest Icon'}
                                                    />
                                                    <Typography
                                                        style={{ paddingLeft: 20 }}
                                                        align="left"
                                                        variant="body1"
                                                    >
                                                        {t('instantRent.addLease')}
                                                    </Typography>
                                                </Box>
                                                {!showEmailForm && (
                                                    <Button
                                                        fullWidth
                                                        color="primary"
                                                        variant={showEmailForm ? 'outlined' : 'contained'}
                                                        className={`${classes.responsiveButton}`}
                                                        onClick={() => noAdditionalApplicants()}
                                                    >
                                                        <Typography variant="h6">
                                                            {t('instantRent.proceedToNextStep')}
                                                        </Typography>
                                                    </Button>
                                                )}
                                                {!showEmailForm && (
                                                    <Box
                                                        style={{
                                                            marginBottom: '10px'
                                                        }}>
                                                        <Button
                                                            fullWidth
                                                            color="primary"
                                                            className={`${classes.responsiveButton}`}
                                                            style={{
                                                                boxShadow: '0px 0px 10px rgb(0 0 0 / 20%)',
                                                                marginBottom: '10px'
                                                            }}
                                                            onClick={addNewTenant}
                                                        >
                                                            <Typography variant="h6">
                                                                {t('instantRent.addNewApplicant')}
                                                            </Typography>
                                                        </Button>
                                                        {emailSent && (
                                                            <Typography variant="body2"
                                                                style={{ marginTop: '8px', color: '#94004A', textAlign: 'center' }}
                                                            >
                                                                {t('afterShowing.emailSent')}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                )}
                                                {showEmailForm && (
                                                    <Box style={{ marginBottom: '10px' }}>
                                                        <TextField
                                                            fullWidth
                                                            label={t('afterShowing.emailAddress')}
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            variant="outlined"
                                                            type="email"
                                                            style={{ marginTop: '10px' }}
                                                        />
                                                        <Button
                                                            fullWidth
                                                            color="primary"
                                                            variant="contained"
                                                            className={`${classes.responsiveButton}`}
                                                            onClick={handleSendEmail}
                                                            style={{ marginTop: '10px' }}
                                                        >
                                                            <Typography variant="h6">
                                                                {t('afterShowing.sendEmail')}
                                                            </Typography>
                                                        </Button>
                                                        {emailValidationError && (
                                                            <Typography variant="body2" style={{ marginTop: '8px', color: 'red', textAlign: 'center' }}>
                                                                {t('afterShowing.invalidEmail')}
                                                            </Typography>
                                                        )}
                                                        {emailError && (
                                                            <Typography variant="body2" style={{ marginTop: '8px', color: 'red', textAlign: 'center' }}>
                                                                {t('afterShowing.emailError')}
                                                            </Typography>
                                                        )}
                                                        <Button
                                                            fullWidth
                                                            color="primary"
                                                            variant={showEmailForm ? 'outlined' : 'contained'}
                                                            className={`${classes.responsiveButton}`}
                                                            onClick={() => noAdditionalApplicants()}
                                                        >
                                                            <Typography variant="h6">
                                                                {t('instantRent.proceedToNextStep')}
                                                            </Typography>
                                                        </Button>
                                                    </Box>
                                                )}
                                            </Box>
                                        </ConfirmationDialogRaw>
                                    </div>
                                </>
                            ) : null}

                        </Grid>
                    </Grid>
                )}
            </Grid>
        </form >
    )
}

const selector = formValueSelector('InstantRentForm')

const mapStateToProps = (state: StateInterface) => ({
    movingWithAmount: selector(state, 'movingWithAmount'),
    contactEmail: selector(state, 'contactEmail'),
    phoneNumber: selector(state, 'phoneNumber'),
    autocompleteLocation: selector(state, 'autocompleteLocation'),
    postalCode: selector(state, 'postalCode'),
    postalArea: selector(state, 'postalArea'),
    acceptedOnlineBanking: selector(state, 'acceptedOnlineBanking')
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeFormValue: (field: string, value: string) =>
        dispatch(change('InstantRentForm', field, value)),
    doNextStep: (beforeLogin: boolean) =>
        dispatch(stepAfterShowingForward({ beforeLogin }))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: 'InstantRentForm'
    })(
        withStyles(styles)(withTranslation()(InstantRentForm as any)) as any
    ) as any
) as any
